export type Styles = {
  theme: {
    colours: {
      primary: string
      primaryTint1: string
      primaryTint2: string
      primaryTint3: string
      secondary: string
      light: string
      lightTint1: string
      lightTint2: string
      lightTint3: string
      lightTint4: string
      lightOverlay1: string
      lightOverlay2: string
      dark: string
      darkTint1: string
      darkTint1Overlay: string
      darkOverlay1: string
      darkOverlay2: string
      warning: string
      transparentBlue: string
      success: string
      info: string
      experiencesCategory: string
    }
    font: {
      fontSizeSmall: string
      fontSizeDesktop: string
      fontSizeNavigationMobile: string
      fontSizeLargeDesktop: string
      fontWeightNormal: number
      fontWeightBold: number
      fontWeightBolder: number
      fontWeightBlack: number
    }
    layout: {
      maxWidth: string
    }
    animation: {
      defaultLength: string
      longLength: string
    }
    padding: {
      mobileDefault: string
      tabletDefault: string
      screenDefault: string
    }
    breakpoints: {
      toTinyScreen: string
      toSmallScreen: string
      toMediumScreen: string
      toNormalScreen: string
      toLargeScreen: string
      toXLargeScreen: string
      fromTinyScreen: string
      fromSmallScreen: string
      fromMediumScreen: string
      fromNormalScreen: string
      fromLargeScreen: string
      fromXLargeScreen: string
    }
    icon: {
      defaultSize: string
      largeSize: string
      smallSize: string
    }
  }
}

export const breakpointValues = {
  toTinyScreen: 400,
  toSmallScreen: 600,
  toMediumScreen: 800,
  toNormalScreen: 1000,
  toLargeScreen: 1200,
  toXLargeScreen: 1450,
  fromTinyScreen: 401,
  fromSmallScreen: 601,
  fromMediumScreen: 801,
  fromNormalScreen: 1001,
  fromLargeScreen: 1201,
  fromXLargeScreen: 1751,
}

const theme = {
  colours: {
    primary: '#0091FF',
    primaryTint1: '#175E93',
    secondary: '#E65100',
    light: '#ffffff',
    lightTint1: '#8D8D94',
    lightTint2: '#BABBC2',
    lightTint3: '#E6E6EB',
    lightTint4: '#F5F5F5',
    lightOverlay1: 'rgba(255, 255, 255, 0.4)',
    lightOverlay2: 'rgba(255, 255, 255, 0.2)',
    dark: '#000000',
    darkTint1: '#383838',
    darkTint1Overlay: 'rgba(56, 56, 56, 0.9)',
    darkOverlay1: 'rgba(0, 0, 0, 0.6)',
    darkOverlay2: 'rgba(0, 0, 0, 0.2)',
    warning: 'rgba(199,0,0,1)',
    transparentBlue: 'rgba(0,116,205,0.5)',
    info: 'rgba(0,116,205,1)',
    success: 'rgba(25,138,0,1)',
    experiencesCategory: '#D500F9',
    countdownTag: '#93328B',
  },
  font: {
    fontSizeSmall: '1.2rem',
    fontSizeDesktop: '1.4rem',
    fontSizeNavigationMobile: '1.8rem',
    fontSizeLargeDesktop: '6.2rem',
    fontWeightNormal: 400,
    fontWeightBold: 600,
    fontWeightBolder: 700,
    fontWeightBlack: 900,
  },
  layout: {
    maxWidth: '144rem',
  },
  animation: {
    defaultLength: '0.2s',
    longLength: '1s',
  },
  padding: {
    mobileDefault: '2rem',
    tabletDefault: '5rem',
    screenDefault: '10rem',
  },
  breakpoints: {
    toTinyScreen: `(max-width: ${breakpointValues.toTinyScreen}px)`,
    toSmallScreen: `(max-width: ${breakpointValues.toSmallScreen}px)`,
    toMediumScreen: `(max-width: ${breakpointValues.toMediumScreen}px)`,
    toNormalScreen: `(max-width: ${breakpointValues.toNormalScreen}px)`,
    toLargeScreen: `(max-width: ${breakpointValues.toLargeScreen}px)`,
    toXLargeScreen: `(max-width: ${breakpointValues.toXLargeScreen}px)`,
    fromTinyScreen: `(min-width: ${breakpointValues.fromTinyScreen}px)`,
    fromSmallScreen: `(min-width: ${breakpointValues.fromSmallScreen}px)`,
    fromMediumScreen: `(min-width: ${breakpointValues.fromMediumScreen}px)`,
    fromNormalScreen: `(min-width: ${breakpointValues.fromNormalScreen}px)`,
    fromLargeScreen: `(min-width: ${breakpointValues.fromLargeScreen}px)`,
    fromXLargeScreen: `(min-width: ${breakpointValues.fromXLargeScreen}px)`,
  },
  icon: {
    defaultSize: '2.4rem',
    largeSize: '5rem',
    mediumSize: '3.4rem',
    medSmallSize: '2.4rem',
    smallSize: '1.8rem',
  },
}

export default theme
